export const initialAbility = [
  {
    subject: 'Home',
    action: 'read',
  },
]

export const _ = undefined
